'use client'

import type {ReactNode} from 'react'
import {menus} from '@/lib/constants'

export function PageHeader({title, description, action, icon}: {
    title: string
    description?: string
    action?: ReactNode
    icon?: ReactNode
}) {
    const inferredIcon = icon || menuIconForTitle(title)

    return (
        <header className="min-h-[60px] px-4 md:px-6 py-2 flex items-center justify-between gap-3 border-b border-hair bg-page shrink-0">
            <div className="flex items-center gap-3 min-w-0">
                {inferredIcon ? (
                    <div className="shrink-0 text-accent flex items-center">
                        {inferredIcon}
                    </div>
                ) : null}
                <div className="flex flex-col gap-0.5 min-w-0">
                    <h2 className="text-base font-medium text-ink truncate">{title}</h2>
                    {description ? <p className="text-xs text-muted truncate">{description}</p> : null}
                </div>
            </div>
            {action ? <div className="flex items-center gap-2 shrink-0 max-w-[55%]">{action}</div> : null}
        </header>
    )
}

function menuIconForTitle(title: string): ReactNode {
    const item = menus.settings.items.find((entry) => title === entry.label || title.startsWith(`${entry.label} `))
    if (item) {
        const Icon = item.icon
        return <Icon size={18}/>
    }
    return null
}
